import type { ColoredLabel } from '@atlassian/jira-issue-shared-types/src/common/types/labels-type.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { type Action, createHook, createStore } from '@atlassian/react-sweet-state';

type ColoredLabelsState = {
	coloredLabelSuggestions: {
		[key: string]: ColoredLabel[];
	};
	coloredLabelSuggestionsMap: {
		[key: string]: string;
	};
};

const actions = {
	addLabelsSuggestions:
		(fieldId: string, label: ColoredLabel): Action<ColoredLabelsState> =>
		({ setState, getState }) => {
			const labelSuggestions = getState().coloredLabelSuggestions;
			const suggestions = labelSuggestions ? labelSuggestions[fieldId] : [];

			const alreadyExists = suggestions.some((existingLabel) => existingLabel.name === label.name);

			if (alreadyExists) return;

			setState({
				coloredLabelSuggestions: {
					[fieldId]: [...suggestions, label],
				},
			});
		},
	labelToColoredLabel:
		(labelName: string, labelColor?: string | null): Action<ColoredLabelsState> =>
		({ getState, setState }) => {
			const coloredLabelSuggestions = getState().coloredLabelSuggestionsMap;

			if (!Object.prototype.hasOwnProperty.call(coloredLabelSuggestions, labelName) && labelColor) {
				coloredLabelSuggestions[labelName] = labelColor;
			} else {
				return;
			}

			setState({ coloredLabelSuggestionsMap: coloredLabelSuggestions });
		},
};

type Actions = typeof actions;

const store = createStore<ColoredLabelsState, Actions>({
	initialState: {
		coloredLabelSuggestions: {
			labels: [],
		},
		coloredLabelSuggestionsMap: {},
	},
	actions,
	name: 'ColoredLabels',
});

export const useLabelsStoreHook = createHook(store);

export const useLabelsStore = () => {
	const labelsStore = useLabelsStoreHook();
	return labelsStore;
};
